module.exports = __webpack_public_path__ + "img/wxpay.9a2bebb1.svg";